import { render, staticRenderFns } from "./pageData.vue?vue&type=template&id=1b532fbd&scoped=true&"
import script from "./pageData.vue?vue&type=script&lang=js&"
export * from "./pageData.vue?vue&type=script&lang=js&"
import style0 from "./pageData.vue?vue&type=style&index=0&id=1b532fbd&lang=scss&scoped=true&"
import style1 from "./pageData.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b532fbd",
  null
  
)

export default component.exports